<template>
    <FormSection title="Payer Comments" type="his-section" :full-height="false" :application-id="Number(application)">
        <template #content>
            <section class="d-flex flex-column px-3 py-2">
                <TemplateInput
                    :templates="referralOptions.template"
                    :application="application"
                    :accountId="accountId"
                    :result="
                        referral.Insurance.AdditionalBillingInfo.PayerComment
                            ? referral.Insurance.AdditionalBillingInfo.PayerComment
                            : ''
                    "
                    v-on:resultUpdated="handleCommentsChanged"
                />
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./PayerComments.ts"></script>
